import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { useHeaderData } from '../../../hooks/use-header-data';
import { Icons, Image, Link } from '@miro-site/ui-design-system';
import classNames from 'classnames';
import styles from './sidebar.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IMAGE_WIDTH = 45;
var IMAGE_HEIGHT = 45;
var BORDER_WIDTH_OFFSET = 1;
export var NavButton = function NavButton(props) {
  var headerData = useHeaderData();
  var selectItem = props.selectItem,
      _props$showChevron = props.showChevron,
      showChevron = _props$showChevron === void 0 ? false : _props$showChevron,
      style = props.style,
      _props$title = props.title,
      title = _props$title === void 0 ? '' : _props$title,
      _props$path = props.path,
      path = _props$path === void 0 ? '' : _props$path,
      image = props.image;
  return /*#__PURE__*/_jsx("li", {
    role: "menuitem",
    children: /*#__PURE__*/_jsxs(Link, {
      className: classNames(styles.drawerItem, 'text-black justify-content-between', {
        active: (headerData === null || headerData === void 0 ? void 0 : headerData.currentPath) === path
      }),
      style: style,
      fluid: true,
      fluidContent: true,
      href: path ? path : undefined,
      onClick: function onClick() {
        if (typeof selectItem === 'function') {
          selectItem(title);
        }
      },
      children: [/*#__PURE__*/_jsxs("div", {
        className: "d-inline-flex gap-200",
        children: [image && /*#__PURE__*/_jsx("div", {
          style: {
            width: "".concat(IMAGE_WIDTH + BORDER_WIDTH_OFFSET, "px"),
            height: "".concat(IMAGE_HEIGHT + BORDER_WIDTH_OFFSET, "px")
          },
          className: "rounded-50 border border-image-idle overflow-hidden",
          children: /*#__PURE__*/_jsx(Image, {
            className: "align-self-center",
            image: _objectSpread(_objectSpread({}, image), {}, {
              width: IMAGE_WIDTH,
              height: IMAGE_HEIGHT
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "align-self-center",
          children: title.trim()
        })]
      }), showChevron && /*#__PURE__*/_jsx(Icons.ChevronRight, {
        className: "align-self-center",
        size: 300
      })]
    })
  }, title);
};